/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [lenovoid]
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import queryString from 'query-string';
import { EnumAPI } from '../../apis/index';
import { AppSourceIdForBU } from '../../constant';
import { EnumUserSourceType } from '../../enums';
import AppConfig from '../../env';
import {
  AjaxBasics,
  BaseModel,
  CustomRegulars,
  LidEncryption,
} from '../../libraries';

@BindAll()
export class LenovoidController {
  readonly Model = new BaseModel({ type: 'object', storageKey: 'lenovoid' });
  // lenovoid_wust = null // lenovoid单点登录code

  get newUser() {
    return lodash.get(this.Model.value, 'newUser');
    // return true
  }
  get checkCode() {
    return lodash.get(this.Model.value, 'checkCode');
  }
  get registerLoginCode() {
    return lodash.get(this.Model.value, 'registerLoginCode');
  }
  @computed
  get username() {
    return lodash.replace(
      lodash.get(this.Model.value, 'username'),
      CustomRegulars.phoneInsensitive,
      '$1****$2',
    );
  }
  /**
   * 检查lenovo登录状态
   */
  async checkLenovoidLogin(lenovoid_wust) {
    try {
      // let oPayload = {
      //     exp: Number(moment().add(10, 's').format('X')),
      //     iat: Number(moment().subtract(3, 's').format('X')),
      //     lenovoToken: lenovoid_wust
      // };
      // const lenovoJwtToken = LidEncryption.JWT(oPayload, AppConfig.lenovoidSecret)
      const res: any = await AjaxBasics.request({
        ...EnumAPI.accountsvr_lenovoid_check_login,
        // body: { lenovoJwtToken }
        body: { lenovoToken: lenovoid_wust },
      });
      this.Model.merge(res);
      return res;
    } catch (error) {
      console.log('zhaoyu ~ error', error);
    }
  }

  /**
   * 检查lenovo  checkcode注册
   */
  async lenovoidRegister(body) {
    const appId = lodash.get(body, 'query.appId');
    const BU = lodash.get(AppSourceIdForBU, appId);
    const res: any = await AjaxBasics.request({
      ...EnumAPI.accountsvr_lenovoid_checkcode_register,
      body: lodash.assign(lodash.omit(body, 'query'), {
        appId: appId || EnumUserSourceType.bppNew,
        checkCode: this.checkCode,
      }),
      headers: BU ? { 'x-business-unit': BU } : {},
    });
    this.Model.merge(res);
    return res;
  }

  /**
   * 解析LIDResult
   */
  decodeLIDResult(LIDResult) {
    try {
      const LIDResultStr = LidEncryption.base64UrlDecode(LIDResult);
      const LIDResultObj = LIDResultStr ? JSON.parse(LIDResultStr) : {};
      if (!lodash.isEmpty(LIDResultObj)) {
        this.Model.merge(LIDResultObj);
      }
      console.log('zhaoyu ~ LIDResultObj', this.Model);
    } catch (error) {}
  }

  /**
   * 生成lid登录地址
   */
  createLidUrl(isPc) {
    const ctx = isPc ? 'cGM=' : 'bW9iaWxl'; //base64串
    const url = queryString.stringifyUrl({
      url: `${AppConfig.lidDomain}/preLogin`,
      query: {
        'lenovoid.action': 'uilogin',
        'lenovoid.realm': 'bp.lenovo.com',
        'lenovoid.cb': `${window.location.origin}/api/gateway/idaas/v1/lenovo-id/login/callback`,
        'lenovoid.ctx': ctx,
        'lenovoid.hideregemail': '0',
        'lenovoid.hideloginreg': '0',
        'lenovoid.hideqrlogin': '0',
        'lenovoid.hidemaillogin': '0',
        'lenovoid.hidelanguage': '0',
        'lenovoid.hidewechat': '0',
        'lenovoid.hideqq': '0',
        'lenovoid.hidesina': '0',
      },
    });
    return url;
  }

  /**
   * 生成lid登出地址
   */
  createLidLoginoutUrl(isPc) {
    const ctx = isPc ? 'cGM=' : 'bW9iaWxl'; //base64串
    const url = queryString.stringifyUrl({
      url: `${AppConfig.lidDomain}/gateway`,
      query: {
        'lenovoid.action': 'uilogout',
        'lenovoid.realm': 'bp.lenovo.com',
        'lenovoid.cb': window.location.origin,
        'lenovoid.ctx': ctx,
        'lenovoid.hidelanguage': '0',
        'lenovoid.hideloginreg': '0',
        'lenovoid.hidemaillogin': '0',
        'lenovoid.hideqq': '0',
        'lenovoid.hideqrlogin': '0',
        'lenovoid.hideregemail': '0',
        'lenovoid.hidesina': '0',
        'lenovoid.hidewechat': '0',
      },
    });
    return url;
  }
}
